import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Icon, Typography } from '@popmenu/common-ui';
import { ExternalLink } from '@popmenu/web-icons';
import { makeStyles } from '../../../utils/withStyles';
import type { RootPlaceMenuItemQuery_rootPlace_RootPlace_menuItem_MenuItem as DishType } from '../../../libs/gql/queries/root_places/rootPlaceMenuItemQuery.generated';

const useStyles = makeStyles(theme => ({
  name: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.25rem',
    },
    fontSize: '2rem',
    lineHeight: 'normal',
  },
  restaurantLink: {
    color: theme.palette.text.primary,
    textDecoration: 'none',
  },
}));

export const DishModalDishTitle = ({ dish }: { dish: DishType }) => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Typography>
        <a
          className={classes.restaurantLink}
          href={dish.restaurant.popmenuUrl ?? undefined}
          rel="noopener"
          target="_blank"
        >
          <FormattedMessage
            id="dish_modal.restaurant_name"
            defaultMessage="{restaurantName} in {city}, {stateOrCountry}"
            values={{
              city: dish.location?.city,
              restaurantName: dish.restaurant.name,
              stateOrCountry: dish.location?.state || dish.location?.countryName,
            }}
          />
          {' '}
          <Icon icon={ExternalLink} />
        </a>
      </Typography>
      <Typography className={classes.name} component="h1">
        {dish.displayName}
      </Typography>
    </React.Fragment>
  );
};
